<template>
  <div id="ArticleCreate">
    <!-- success msg component 
    <Success :msg="msg" v-show="success" />
    <ProductForm :user="user" @submit-form="saveUser" hasCustomer=true buttonText="Guardar" />
     -->
    <ProductForm :user="user" :submitForm="addRow" buttonText="Guardar" hasReset=true hasArticle=true hasProductCreate=true />
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import ProductForm from "@/components/ProductForm";
//import Success from "./Success";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: "ArticleCreate",
  computed:{
    ...mapState(['currentUser']),    
  },
  components: {
    ProductForm,
    //Success,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      success: false,
      msg: "",
    };
  },
  methods: {
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    async addRow(ProductInfo){
      this.showLoading({titulo:"Almacenando información",color:"warning"})
      // alert("Agregar Product");
      // alert (ProductInfo.quote_id);
      // alert (ProductInfo.pricelist_id);
      // alert (ProductInfo.cantidad);
      // alert (ProductInfo.price);
      try{         
        // let branch_id=this.currentUser.branch_id;
        let sku=ProductInfo.sku;
        let brand_id=ProductInfo.brand_id;
        let line_id=ProductInfo.line_id;
        let peso=ProductInfo.peso;
        let alto=ProductInfo.alto;
        let ancho=ProductInfo.ancho;
        let largo=ProductInfo.largo;
        let measurement_id=ProductInfo.measurement_id;        
        let famcategory_id=ProductInfo.famcategory_id;
        let subfamily_id=ProductInfo.subfamily_id;
        let modelo=ProductInfo.modelo;
        let clave_sat=ProductInfo.clave_sat;
        let description=ProductInfo.description;    
        let title=ProductInfo.title;    
        let filename=ProductInfo.filename;        
        let type_article=ProductInfo.type_article;        

        // const { id, branch_id, supplier_id, warehouse_id, product_id, famcategory_id, price,iva,iva_referencia } = this;
        await icheckApi().post(`/articulos`,JSON.stringify({ famcategory_id, subfamily_id,sku,modelo, clave_sat, line_id,brand_id, title,description, measurement_id,peso,alto,ancho,largo,filename, type_article })).then((response)=>{       
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              // this.$swal("Error!",response.data.message, "error");
              this.$swal("Error!",response.data.message+': <br/>'+JSON.stringify(response.data.validate), "error"); 
            }                                    
          });
      }catch(error){
        //code
      }  finally{
        this.hiddenLoading()
      }
    },
  },
};
</script>